import React from 'react';
import styles from '../styles/QuestionTracker.module.css';
import { ProgressPhase } from '../types/interview';
import { useUiCopy } from '../i18n/useUiCopy';

interface QuestionTrackerProps {
  currentStep: number;
  totalSteps: number;
  interviewPhase: ProgressPhase;
}

const QuestionTracker: React.FC<QuestionTrackerProps> = ({ currentStep, totalSteps, interviewPhase }) => {
  const copy = useUiCopy();
  // Don't render if we don't have valid data
  if (!Number.isFinite(currentStep) || !Number.isFinite(totalSteps) || totalSteps <= 0 || currentStep <= 0) {
    return null;
  }

  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  let title: string;

  switch (interviewPhase) {
    case 'VERIFICATION':
      title = copy.generalQuestions;
      break;
    case 'STANDARD':
      title = copy.personalizedQuestions;
      break;
    default:
      title = copy.generalQuestions;
      break;
  }

  return (
    <div className={styles.trackerContainer}>
      <div className={styles.trackerLabel}>{title}</div>
      <div className={styles.dotsContainer}>
        {steps.map((step) => (
          <div
            key={step}
            className={`${styles.step} ${
              step === currentStep ? styles.active : ''
            } ${step < currentStep ? styles.completed : ''}`}
            title={copy.questionOf(step, totalSteps)}
          />
        ))}
      </div>
      <div className={styles.progressText}>
        {copy.progressOf(currentStep, totalSteps)}
      </div>
    </div>
  );
};

export default QuestionTracker;
